import styled from "styled-components";
import { COLORS } from "../../../constants";

const Container = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;
const GeneralProgressContainer = styled.div`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border-radius: 20px;
  background: ${COLORS.WHITE};
`;

const GeneralProgressionLabel = styled.p`
  color: ${COLORS.DARK};
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

const CategoryLabel = styled.h2`
  color: ${COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const LevelCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  height: 60px;
  width: 100%;
  max-width: ${window.innerWidth/2}px;
  padding: 10px 20px;
  gap: 10px;
  border-radius: 20px;
  background: ${COLORS.WHITE};
  cursor: pointer;
  &:hover {
    box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 6px;
  }
`;

const LevelCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: '100%';
`;

const ReadProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 20px;
  background: ${COLORS.WHITE};
`;

const DropContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F9F2F2;
  gap: 20px;
  max-width: '100%';
  margin: 20px auto;
`;

const DroppableContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
`;

const DragContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 20px;
  align-self: stretch;
  flex-wrap: wrap;
  border-radius: 0px 0px 30px 30px;
  background: #F9F2F2;
`;

const ValidateButton = styled.button`
  display: flex;
  padding: 10px;
  align-items: center;
  gap: 10px;
  margin: 10px;
  border-radius: 10px;
  background: #C3645E;
  border-style: none;
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0 auto;
  cursor: pointer;
  &:disabled {
    cursor: auto;
    color: ${COLORS.DARK};
    background: ${COLORS.SECONDARY};
  }
`;

const Label = styled.label`
  color: #C3645E;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ModalTitle = styled.h3`
  color: ${COLORS.DARK};
  text-align: center;
  padding: 0px 16px;
  margin: 0;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
`;

const ModalContent = styled.div`
  color: ${COLORS.DARK};
  text-align: center;
  padding: 0px 16px;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const ModalButton = styled.p<{ $color?: string; }>`
  color: ${props => props.color ? props.color : COLORS.PRIMARY};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;
  margin-bottom: 8px;
  cursor: pointer;
`;

const QuizzSelect = styled.select`

`;

export {
  GeneralProgressContainer,
  GeneralProgressionLabel,
  Container,
  CategoryLabel,
  LevelCard,
  LevelCardContainer,
  ReadProgressContainer,
  DropContainer,
  DroppableContainer,
  DragContainer,
  ValidateButton,
  Label,
  ModalButton,
  ModalContent,
  ModalTitle,
  QuizzSelect,
}